import { Editor, Element } from 'slate';

export function elements(editor: Editor) {
    return Editor.nodes(editor, { match: n => Element.isElement(n) });
}
